import { useMemo } from 'react';
import { Attributes } from '@leverege/ui-attributes';
import { Project, System } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
function Renderer(props) {
  const {
    value,
    model,
    object
  } = props;
  const attribute = Attributes.getAttribute(model.attrName, model.objectType);
  const label = useMemo(() => {
    const enumType = attribute?.source?.attribute?.model?.enumType;
    if (!enumType) {
      return value;
    }
    let enumData;
    if (attribute.valueType === 'enum') {
      const projectId = object?.data?.projectId;
      if (!projectId) {
        return value;
      }
      enumData = Project(projectId).enum(enumType).getEnum(GlobalState.get());
    } else {
      const systemId = object?.data?.systemId;
      if (!systemId) {
        return value;
      }
      enumData = System(systemId).resourceEnum(enumType).getResourceEnum(GlobalState.get());
    }
    if (!enumData) {
      return value;
    }
    return enumData.values.find(v => v.value === value)?.name || value;
  }, [value, attribute, object]);
  return label;
}
export default {
  createRenderer(valueType) {
    return {
      id: `molten.CustomTextValueRenderer.${valueType}`,
      valueType,
      Component: Renderer
    };
  }
};